import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SetupHeaderButtonType,
  SetupPageHeader,
} from '../../../../../../components/SetupPageHeader';
import { replaceFinalSegment } from '../../../../../../utils/url';
import { CreateJobDto } from '../../../../../../services/applicant_tracking/JobService/CreateJobDto';
import { useStateMachine } from 'little-state-machine';
import { FormState } from 'react-hook-form';
import { JobDetails } from '../../../../../../services/applicant_tracking/JobService/EditJobDto';
import { SetupPageFooter } from '../../../../../../components/SetupPageFooter';

interface PropTypes {
  formState: FormState<CreateJobDto>;
  jobDetails: JobDetails;
  setupStep: number;
  setSetupStep: (newStep: number, jobDTO: CreateJobDto) => void;
  onSave: () => void;
  onCancel: () => void;
  onNavigate: () => void;
  isEditFlow: boolean;
  isLoading: boolean;
  children?: React.ReactNode;
}

export function JobPostPageLayout(props: PropTypes) {
  const isLoadingOrFormInvalid = props.isLoading || !props.formState.isValid;
  const navigate = useNavigate();
  const { state } = useStateMachine();

  const saveAsDraft: SetupHeaderButtonType = {
    title: 'Save as Draft',
    type: 'Save',
    action: props.onSave,
    disabled: isLoadingOrFormInvalid,
  };

  const firstItems: SetupHeaderButtonType[] = [
    {
      title: 'Previous',
      type: 'Navigate',
      action: () => {
        props.onNavigate();
        props.setSetupStep(props.setupStep - 1, state.setupJob);
        navigate(replaceFinalSegment('job_details'));
      },
    },
  ];

  const nextButton: SetupHeaderButtonType = {
    title: 'Next',
    type: 'Navigate',
    action: () => {
      props.onNavigate();
      props.setSetupStep(props.setupStep + 1, state.setupJob);
      navigate(replaceFinalSegment('application_form'));
    },
    disabled: isLoadingOrFormInvalid,
  };

  const saveButtonText =
    props.isEditFlow && props.jobDetails?.status === 'published'
      ? 'Save and Publish'
      : 'Save and Continue';

  const saveButton: SetupHeaderButtonType = {
    title: saveButtonText,
    type: 'Save',
    disabled: isLoadingOrFormInvalid,
  };

  if (props.isEditFlow) {
    firstItems.push(nextButton);
  }

  return (
    <>
      <SetupPageHeader
        title='Job Post'
        firstItems={firstItems}
        intermediateItems={[
          {
            title: 'Cancel',
            type: 'Cancel',
            action: props.onCancel,
          },
          {
            title: saveButtonText,
            type: 'Save',
            disabled: isLoadingOrFormInvalid,
          },
        ]}
      />
      {props.children}
      {!props.isLoading && (
        <SetupPageFooter
          classNames='mt-4'
          firstItem={saveButton}
          lastItem={props.isEditFlow ? null : saveAsDraft}
        />
      )}
    </>
  );
}
